// extracted by mini-css-extract-plugin
export default {"description":"_64u81zpmoxMply7d6wOaTV"};